import './utils/lite-youtube-embed'
import './style/styles-hp.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/hp'

Object.values(features).forEach(createComponent)
